export enum QueryParam {
  NextUrl = 'nextUrl',
}
